import { render, staticRenderFns } from "./SpecimenPlate.vue?vue&type=template&id=55ebe69a&scoped=true"
import script from "./SpecimenPlate.vue?vue&type=script&lang=js"
export * from "./SpecimenPlate.vue?vue&type=script&lang=js"
import style0 from "./SpecimenPlate.vue?vue&type=style&index=0&id=55ebe69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ebe69a",
  null
  
)

export default component.exports